var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_5550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7C8.66663 7 5.81996 9.07333 4.66663 12C5.81996 14.9267 8.66663 17 12 17C15.3333 17 18.18 14.9267 19.3333 12C18.18 9.07333 15.3333 7 12 7ZM12 15.3333C10.16 15.3333 8.66663 13.84 8.66663 12C8.66663 10.16 10.16 8.66667 12 8.66667C13.84 8.66667 15.3333 10.16 15.3333 12C15.3333 13.84 13.84 15.3333 12 15.3333ZM12 10C10.8933 10 9.99996 10.8933 9.99996 12C9.99996 13.1067 10.8933 14 12 14C13.1066 14 14 13.1067 14 12C14 10.8933 13.1066 10 12 10Z",
    fill: "#B6B8D5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_5550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnEye);
export default __webpack_public_path__ + "static/media/icn-eye.ef3580adc3b611379f728f0c37725079.svg";
export { ForwardRef as ReactComponent };